import BasePage from "@/infrastructure/BasePage/basePage.component";
import React from "react";
import { useTranslation } from "react-i18next";

type PageDashboardProps = {
  // TODO: add props here
};

const PageDashboard: React.FC<PageDashboardProps> = (props) => {
  const { t } = useTranslation();

  return (
    <BasePage currPage="Dashboard">
      <div className="h-full overflow-y-auto">Dashboard</div>
    </BasePage>
  );
};

export default PageDashboard;
